(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/crypto-giving/views/directives/crypto-giving.views.directives.qr-code', '<div id="cg-qr-code"></div>\n' + '');
}]);
})();